

<p-dialog  header="Nouveau message" [resizable]='true' [baseZIndex]="99999999" [(visible)]="ismail" [modal]="false" [maximizable]="true"
    [responsive]="true"  appendTo="body"   
       *ngIf='mail && ismail' [ngStyle]="{'width': '80vw','height':'80vh'}"    [minY]="250"  >
    <p-header>
        <span style="float: right;cursor: pointer;" (click)="toggle()">
            <mat-icon class="mat-18">{{icon}}</mat-icon>
        </span>
  
     
    </p-header>
    <!--
    <p-growl [(value)]="msgs" [baseZIndex]='999999999'></p-growl>
    -->



    <form action="" method="post" enctype="multipart/form-data" accept-charset="utf-8" class="form-horizontal">
        <div class="row">
            <div style="opacity: 0;" id='bottomConf'>

            </div>
            <div style="width: 100%;margin-bottom: 5px" id='headerConf'>

            </div>
        </div>
        <div class="row">
            <div class="col-1 textImage ">
                <div class="btn" (click)="sendEmail()" style="  border-radius: 4px;border:  gray 1px;border-style: dotted;height: 78px; cursor: pointer;">
                    <a style=" margin-top: 20px!important; ">
                        <img style=" height: 20px; cursor: pointer;margin-top: 15px!important;" src="assets/img/sendmail.png"
                            alt="Send email">
                         </a>
                    <p style="font-weight: inherit">Send</p>
                </div>

            </div>
            <div class="col-11">

                <div class="row">
                    <label class="col-1" style="font-weight: inherit;   color: #05164d ;border-radius: 4px;border:  gray 1px;border-style: dotted;">
                        From </label>
                    <div class="col-9">

                        <a> {{mail.froma}} </a>


                    </div>

                </div>

                <div class="row">
                    <label class="col-1" style="font-weight: inherit;   color: #05164d ;cursor: pointer;border-radius: 4px;border:  gray 1px;border-style: dotted;"
                        (click)='isContacts=true'>
                        {{typeRepMail}} To... </label>
                    <div class="col-9">
                        <tag-input [(ngModel)]="tto" [modelAsStrings]="true" addOnPaste='true' addOnBlur='true'
                            [editable]='true' name='mailTo' #mailTo='ngModel'>
                            <tag-input-dropdown [autocompleteObservable]='requestAutocompleteItems'></tag-input-dropdown>
                        </tag-input>


                    </div>
                    <div class="col-2">
                        <button style="font-weight: inherit;   color: #05164d ;" *ngIf='!isCC && !isBCC' (click)='isCC=true'
                            class="btn btn-sm  btn-link">CC</button>
                        <button style="font-weight: inherit;   color: #05164d ;" *ngIf='!isCC && !isBCC' (click)='isBCC=true'
                            class="btn btn-sm  btn-link">BCC</button>
                    </div>
                </div>
                <div *ngIf='isCC' class="row">
                    <label class="col-1" style="font-weight: inherit;   color: #05164d ;"> CC... </label>
                    <div class="col-9">
                        <tag-input [(ngModel)]="cc" [modelAsStrings]="true" addOnPaste='true' addOnBlur='true'
                            [editable]='true' name='mailCC' #mailCC='ngModel'>
                            <tag-input-dropdown [autocompleteObservable]='requestAutocompleteItems'></tag-input-dropdown>
                        </tag-input>
                    </div>
                    <button *ngIf='!isCC' (click)='isCC=true' class="btn btn-sm  btn-link">CC</button>
                    <button *ngIf='!isBCC' (click)='isBCC=true' class="btn btn-sm  btn-link">BCC</button>

                </div>
                <div *ngIf='isBCC' class="row">
                    <label class="col-1" style="font-weight:inherit;   color: #05164d ;"> BCC... </label>

                    <div class="col-9">
                        <tag-input [(ngModel)]="bcc" [modelAsStrings]="true" addOnPaste='true' addOnBlur='true'
                            [editable]='true' name='mailBcc' #mailBcc='ngModel'>
                            <tag-input-dropdown [autocompleteObservable]='requestAutocompleteItems'></tag-input-dropdown>
                        </tag-input>
                    </div>
                    <button *ngIf='!isCC' style="font-weight: inherit;   color: #05164d ;" (click)='isCC=true' class="btn btn-sm  btn-link">CC</button>
                    <button *ngIf='!isBCC' style="font-weight: inherit;   color: #05164d ;" (click)='isBCC=true' class="btn btn-sm  btn-link">BCC</button>

                </div>
                <div class="row">
                    <label class="col-1" style="font-weight: inherit;   color: #05164d ;cursor: pointer;border-radius: 4px;border:  gray 1px;border-style: dotted;"
                        (click)='isModelMails=true'> Subject </label>
                    <div class="col-9">
                        <input style="width: 100%" [(ngModel)]="mail.objet" name='mailObjet' #mailObjet='ngModel'>

                    </div>
                    <div class="col-2 " style="cursor: pointer;" (click)="browse()">
                        <img src='/assets/img/pjointe1.png' height="20px">
                    </div>

                </div>
                <!--  <p-editor [(ngModel)]="mail.corp" placeholder="Corp" name='mailCorp' #mailCorp='ngModel'></p-editor> -->

                <div style="display: none">


                    <p-fileUpload id="uploads" (click)='clickSend()' #uploadf mode="basic" name="demo[]" url="{{uploadUrl}}"
                        maxFileSize="100000000" (onUpload)="onUpload1($event)" auto="true" chooseLabel="Browse">
                    </p-fileUpload> 
                </div>
            </div>
        </div>
 


  <div *ngFor="let file of uploadedFiles">
    <a style="color: blue;cursor: pointer;font-weight: inherit;background: rgb(246, 246, 246)"
    (click)='openFile(file)'>
    {{file.name}}
       - {{formatBytes(file.size,'')}}</a>
   <button (click)='removePJ(file)' class="btn btn-sm">
       <i class="fa fa-remove"></i>
   </button>

  </div>
 
    

        <ckeditor [(ngModel)]="mail.corp" (blur)='editDraft()' name="first" [config]="CkeditorConfig" [style]="{'height': '100%'}"
            [readonly]="false" debounce="500">
            <ckbutton [name]="'modelButton'" [command]="'modelCmd'" (click)='isModelMails=true' [icon]="'/assets/img/model.png'"
                [label]="'Model text'" [toolbar]="'clipboard,1'"> </ckbutton>

            <ckbutton [name]="'modelPJButton'" [style.width.px]="300" [command]="'sendCmd'" (click)='isModelPjoint=true'
                [icon]="'/assets/img/pjointe.png'" [label]="'Model piéce jointe'" [toolbar]="'clipboard,1'">
            </ckbutton>
            <ckbutton [name]="'PJButton'" [style.width.px]="300" [command]="'pjCmd'" (click)="browse( )" [icon]="'/assets/img/pjointe1.png'"
                [label]="'piéce jointe'" [toolbar]="'clipboard,1'">
            </ckbutton>
        </ckeditor>



    </form>
    <p-footer>

    </p-footer>
</p-dialog>
<p-dialog header="Model mail"  [baseZIndex]="99999999" appendTo="body" styleClass="mydialog"   [(visible)]="isModelMails" [modal]="true" [responsive]="true"
         [minY]="250">
    <ol>
        <li class="btn btn-block" *ngFor="let modelCores of modelsCores" (click)=' onChooseModelCores(modelCores);isModelMails=false'>{{modelCores.designation}}</li>
    </ol>
</p-dialog>
<p-dialog header="Model pjointe"  [baseZIndex]="99999999" appendTo="body" styleClass="mydialog" 
[(visible)]="isModelPjoint" [modal]="true" [responsive]="true"
       [minY]="250">
    <ol>
        <li class="btn btn-block" *ngFor="let modelsPjoint of modelsPjoints" (click)=' onChooseModel(modelsPjoint);isModelPjoint=false'>{{modelsPjoint.designation}}</li>
    </ol>
</p-dialog>
 
<style>
    .ui-dialog {
        right: 0 !important;
        bottom: 0 !important;

        left: inherit !important;
        top: inherit !important;


    }
</style>
 